import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { ChangeDetectorRef, ComponentRef, Injectable } from '@angular/core';
import { BaseInfoService } from '../../account-wizard-helpers/services/base-info.service';
import { AccountPhoneNumberView } from '../../add-account-phone-numbers/models/account-phone-number-view.model';
import { PhoneNumberInfoComponent } from '../location-summary/phone-number-info.component';

@Injectable()
export class PhoneNumberInfoService extends BaseInfoService<PhoneNumberInfoComponent> {
   constructor(overlay: Overlay) {
      super(overlay, PhoneNumberInfoComponent, 'phone-number-info-panel');
   }

   protected updateComponentData(
      componentRef: ComponentRef<PhoneNumberInfoComponent>,
      data: AccountPhoneNumberView
   ): void {
      componentRef.instance.phoneNumber = data;
   }

   showPhoneNumberInfo(
      phoneNumberViewModel: AccountPhoneNumberView,
      button: HTMLElement,
      changeDetectorRef?: ChangeDetectorRef
   ) {
      const connectedPositions: ConnectedPosition[] = [
         {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
         },
         {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
         },
      ];

      const outsidePointerEventsCallback = () => {
         this.selectedId = null;
         changeDetectorRef?.markForCheck();
         this.outsidePointerEvent$.next();
      };

      this.openOverlay(phoneNumberViewModel, button, connectedPositions, outsidePointerEventsCallback.bind(this));

      if (this.selectedId === phoneNumberViewModel.phoneNumber) {
         this.selectedId = null;
      } else {
         this.selectedId = phoneNumberViewModel.phoneNumber ?? null;
      }
   }
}
